import { api } from "@/redux/api";

import { RequestPaginationParams } from "@/types/request-params";

import {
	ExtendPreviewRequest,
	ListPreview,
	ListPreviewResultsResponse,
	ListPreviewResultsResponseSchema,
	ListPreviewSchema,
	RerunPreviewRequest,
	StartPreviewRequest,
} from "../../pages/List/pages/ListEditDetails/schema/listPreview";

export const listPreviewApi = api.injectEndpoints({
	endpoints: (builder) => ({
		startPreview: builder.mutation<ListPreview, { listId: number; body: StartPreviewRequest }>({
			query: ({ listId, body }) => ({
				url: `list/${listId}/preview/start`,
				method: "POST",
				body,
				responseSchema: ListPreviewSchema,
			}),
			invalidatesTags: ["ListPreview"],
		}),
		getPreviewStatus: builder.query<ListPreview, number>({
			query: (listId) => ({
				url: `list/${listId}/preview/status`,
				responseSchema: ListPreviewSchema,
			}),
			providesTags: ["ListPreview"],
		}),
		getPreviewResults: builder.query<
			ListPreviewResultsResponse,
			RequestPaginationParams & { listId: number; previewId?: number }
		>({
			query: ({ listId, previewId, ...params }) => ({
				url: `list/${listId}/preview/results`,
				params: {
					...(params && { ...params }),
					...(previewId && { previewId }),
				},
				responseSchema: ListPreviewResultsResponseSchema,
			}),
			providesTags: ["ListPreview"],
		}),
		stopPreview: builder.mutation<ListPreview, number>({
			query: (listId) => ({
				url: `list/${listId}/preview/stop`,
				method: "POST",
				responseSchema: ListPreviewSchema,
			}),
			invalidatesTags: ["ListPreview"],
		}),
		rerunPreview: builder.mutation<ListPreview, { listId: number; body: RerunPreviewRequest }>({
			query: ({ listId, body }) => ({
				url: `list/${listId}/preview/rerun`,
				method: "POST",
				body,
				responseSchema: ListPreviewSchema,
			}),
			invalidatesTags: ["ListPreview"],
		}),
		extendPreview: builder.mutation<ListPreview, { listId: number; body: ExtendPreviewRequest }>({
			query: ({ listId, body }) => ({
				url: `list/${listId}/preview/extend`,
				method: "POST",
				body,
				responseSchema: ListPreviewSchema,
			}),
			invalidatesTags: ["ListPreview"],
		}),
	}),
});

export const {
	useStartPreviewMutation,
	useGetPreviewStatusQuery,
	useGetPreviewResultsQuery,
	useStopPreviewMutation,
	useRerunPreviewMutation,
	useExtendPreviewMutation,
} = listPreviewApi;
